import { render, staticRenderFns } from "./Proximamente.vue?vue&type=template&id=628a4810"
import script from "./Proximamente.vue?vue&type=script&lang=js"
export * from "./Proximamente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports